import { FC } from 'react';
import { TextField } from 'components/Forms/TextField';
import { ENV_CONFIG } from 'config/environment';
import { DescriptionField } from 'components/Forms/DescriptionField';
import { RadioField } from 'components/Forms/RadioField';
import { SwitchToggleField } from 'components/Forms/SwitchToggleField';
import { RecipientCardsForm } from 'views/Pages/Forms/RecipientCardsForm';
import { UploadFileForm } from 'views/Pages/Forms/UploadFileForm';
import { ColorPickerForm } from 'views/Pages/Forms/ColorPickerForm';
import { useFieldValue } from 'hooks/useFormHelpers';
import { required, transformToUrl } from 'helpers/utils';
import { AdminCartRecipient, RecipientSelectionMode } from 'store/shoppingCart/types';
import { validateQueryString } from './utils';
import { PROCESSING_REDIRECT_OPTIONS } from './constants';
import { RecipientCompatibilityBadge } from './RecipientCompatibilityBadge';
import { RemovedRecipientsList } from './RemovedRecipientsList';

type Props = {
  cartRecipients?: AdminCartRecipient[];
};

const renderCompatibilityBadge = (recipientId: string) => (
  <RecipientCompatibilityBadge recipientId={recipientId} />
);

export const CheckoutPageDesignSection: FC<Props> = ({ cartRecipients }) => {
  const recipientSelectionMode = useFieldValue('recipient_selection_mode') as
    | RecipientSelectionMode
    | undefined;
  const queryString = useFieldValue('query_string') as string | undefined;

  return (
    <>
      <TextField label="Page Name *" name="page_name" type="text" validate={required} />
      <div className="row mb8">
        <div className="col-md-6 padding0">
          <UploadFileForm type="tag" />
        </div>
        <div className="col-md-6 padding0">
          <ColorPickerForm
            bgColorFieldName="page_background"
            textColorFieldName="page_color_text"
          />
        </div>
      </div>
      <DescriptionField label="Page Description" name="page_desc" />
      <TextField
        label="Website URL *"
        name="query_string"
        type="text"
        placeholder="your-page-name"
        validate={validateQueryString}
        parse={value => transformToUrl(value).toLowerCase()}
        format={value => value?.toLowerCase()}
      />
      {queryString && (
        <div className="category form-category query-string">
          {ENV_CONFIG().PARTNER_PAGE}
          {queryString}
        </div>
      )}
      {recipientSelectionMode === RecipientSelectionMode.RECIPIENTS_LIST ? (
        <RecipientCardsForm
          isPreviewVisible={false}
          renderRowExtra={renderCompatibilityBadge}
          afterRecipients={
            cartRecipients && <RemovedRecipientsList cartRecipients={cartRecipients} />
          }
        />
      ) : (
        <div className="row">
          <div className="col-md-4 padding0">
            <RadioField
              name="processing_redirect"
              label="Payment Processor:*"
              options={PROCESSING_REDIRECT_OPTIONS}
            />
          </div>
          <div className="col-md-2 padding0" />
          <div className="col-md-6 padding0">
            <div className="margin0 form-group">
              <SwitchToggleField name="impact_score_visibility" label="Impact Score Visibility" />
            </div>
            <div className="margin0 form-group">
              <SwitchToggleField name="show_more_visibility" label="'Show More' Visibility" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
